import { useEffect, useState } from "react";
import { getAuditActions, getAuditHelpPlacements } from "../../CroActions";
import { registerEnumLabels } from "./enumLabels";

const AUTHOR_ROLES = [
  { id: "ADMIN", label: "Administrátor" },
  { id: "SPRAVCE", label: "Správce" },
  { id: "OVM", label: "Podpůrný orgán" },
  { id: "OPRAVNENY_ORGAN", label: "Oprávněný orgán" },
  { id: "FINANCNI_INSTITUCE", label: "Finanční instituce" },
  { id: "OFFICIAL", label: "Funkcionář" },
  { id: "PUBLIC_USER", label: "Žadatel" },
  { id: "ESM_SYSTEM", label: "ESM systém" },
];

let placementsLoaded = false;

export default function useAuditEnums(auth, dispatch) {
  const [actions, setActions] = useState([]);

  useEffect(() => {
    if (!auth || !auth.startUrl) return;
    getAuditActions(auth.startUrl, dispatch)
      .then((data) => Array.isArray(data) && setActions(data))
      .catch(() => {});

    if (!placementsLoaded) {
      placementsLoaded = true;
      getAuditHelpPlacements(auth.startUrl, dispatch)
        .then((data) => {
          if (Array.isArray(data)) registerEnumLabels("HelpPlacementEnum", data);
        })
        .catch(() => { placementsLoaded = false; });
    }
  }, [auth, dispatch]);

  return { actions, roles: AUTHOR_ROLES };
}
